import { render, staticRenderFns } from "./BetHistory.vue?vue&type=template&id=b8d95d50&scoped=true&"
import script from "./BetHistory.vue?vue&type=script&lang=js&"
export * from "./BetHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d95d50",
  null
  
)

export default component.exports